import { createTheme } from '@mui/material'
import { TextField } from './TextField/TextField'
import { Button } from './Button/Button'
import { Menu } from './Menu/Menu'

declare module '@mui/material/TextField' {
  interface TextFieldPropsSizeOverrides {
    tiny: true
  }
}

export const theme = createTheme({
  typography: {
    h1: {
      fontWeight: 'bold',
      letterSpacing: 0,
      fontSize: '40px',
    },
    h2: {
      fontWeight: 600,
      letterSpacing: -1,
      fontSize: '32px',
    },
    h3: {
      fontWeight: 600,
      letterSpacing: 0,
      fontSize: '24px',
    },
    h4: {
      fontWeight: 600,
      letterSpacing: 0,
      fontSize: '18px',
    },
  },
  palette: {
    primary: {
      contrastText: '#ffffff',
      light: '#f5f7f9',
      // dark: '#25bf7c',
      dark: '#24365E',
      main: '#3F8BE9',
    },
    secondary: {
      contrastText: '#ffffff',
      light: '#24365E',
      dark: '#24365E',
      main: '#24365E',
    },
    muted: {
      main: '#6D7994',
      hint: '#B6BCC9',
      dark: '#3C4C70',
      light: '#e7e9ed',
    },
    gray: {
      main: '#E9E4E6',
      light: '#F6F5F5',
    },
  },
})

export const DefaultTheme = createTheme(theme, {
  components: {
    ...TextField,
    ...Button,
    ...Menu,
  },
})
